// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"aeb8f1ff","148":"15c30744","304":"6aaf96b4","388":"108e4bcd","422":"20264d69","615":"55b72852","752":"1e0da07e","898":"24deaa93","901":"1e0da07e"}[chunkId] + ".chunk.css";
};